import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle py-3 font-medium" }, " Informazioni generali sulla macchina ", -1)
const _hoisted_2 = { class: "p-4 flex-grow-0 justify-content-center w-full lg:w-12/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Table, {
        data: _ctx.getTableData(),
        config: _ctx.getTableConfig()
      }, null, 8, ["data", "config"])
    ])
  ], 64))
}